module.exports = __webpack_public_path__ + "static/media/puzzle-piece-white.fa38c765.png";